import axios from "axios";

const getNotificationOutbox = (query) =>
  axios.get("api/v1/admin/notification-outbox", { params: query });

const getNotificationOutboxHealth = () =>
  axios.get("api/v1/admin/notification-outbox/health");

const retryNotificationOutbox = (id) =>
  axios.post(`api/v1/admin/notification-outbox/${id}/retry`);

const ApiNotificationOutbox = {
  getNotificationOutbox,
  getNotificationOutboxHealth,
  retryNotificationOutbox,
};

export default ApiNotificationOutbox;
